import { render, staticRenderFns } from "./PageTemps.vue?vue&type=template&id=30b9c650&scoped=true"
import script from "./PageTemps.vue?vue&type=script&lang=js"
export * from "./PageTemps.vue?vue&type=script&lang=js"
import style0 from "./PageTemps.vue?vue&type=style&index=0&id=30b9c650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9c650",
  null
  
)

export default component.exports